import { getSessionVar } from '../../../lib/helpers';

export const useCanDownloadLogs = (cloudData) => {
    if (!getSessionVar('allow_logs_download')) return false;

    // Check if the appliance is defined and has the necessary properties
    if (!cloudData || !cloudData.links) return false;

    // Check if the appliance has a link for downloading logs
    const logsObject = cloudData.links.find((link) => link.rel === 'appliance_logs');

    return logsObject.href;
};
